import * as React from "react";
import mitt from "mitt";

export const emitterAccount = mitt();
export const emitterAccountContext = React.createContext(emitterAccount);

export function useAccountEmitter() {
  return React.useContext(emitterAccountContext);
}
